import React from "react";
import "./Common.css";

function HeroStats() {
  const stats = [
    // {
    //   value: "36 Cr+",
    //   title: "Beneficiaries Covered",
    // },
    {
      value: "784",
      title: "Districts Monitored",
    },
    {
      value: "36",
      title: "States & UTs",
    },
    {
      value: "7×7×7",
      title: "Strategy Framework",
    },
  ];

  return (
    <section className="hero-stats-section">
      <div className="container">
        <div className="row text-center">

          {stats.map((item, index) => (
            <div className="col-lg-4 col-6" key={index}>
              <div className="stat-box">
                <h2>{item.value}</h2>
                <p>{item.title}</p>
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}

export default HeroStats;